// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SLi1a","loading":"styles_loading__+2U9Z"};